/**
 * EventPoster - Creates custom designed poster/flyer images
 * Full city image with city name overlay text.
 */

const POSTER_DATA = {
  johannesburg: {
    cityImage: 'https://images.unsplash.com/photo-1581006867287-9f90a3f3a8b0?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=800',
    cityName: 'JOHANNESBURG',
  },
  dallas: {
    cityImage: 'https://images.unsplash.com/photo-1631660975301-b2b65e80c98a?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=800',
    cityName: 'DALLAS',
  },
};

function getCityKey(title) {
  const t = (title || '').toLowerCase();
  if (t.includes('johannesburg') || t.includes('south africa')) return 'johannesburg';
  if (t.includes('dallas')) return 'dallas';
  return null;
}

export default function EventPoster({ eventTitle, className = '' }) {
  const cityKey = getCityKey(eventTitle);
  const data = cityKey ? POSTER_DATA[cityKey] : null;

  if (!data) return null;

  return (
    <div className={`bg-[#f5f0e8] p-6 sm:p-8 ${className}`}>
      {/* Title */}
      <h2
        className="text-center font-body font-light text-2xl sm:text-3xl lg:text-4xl text-gray-900 mb-6 sm:mb-8"
        style={{ letterSpacing: '0.35em' }}
      >
        REVIVAL NIGHT
      </h2>

      {/* Full City Image */}
      <div className="relative overflow-hidden aspect-[16/10] mx-auto max-w-lg">
        <img
          src={data.cityImage}
          alt={data.cityName}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 flex items-end justify-center pb-6">
          <span
            className="text-white font-body font-light text-4xl sm:text-5xl lg:text-6xl"
            style={{ letterSpacing: '0.15em', textShadow: '0 2px 20px rgba(0,0,0,0.5)' }}
          >
            {data.cityName}
          </span>
        </div>
      </div>
    </div>
  );
}
